import { ChangeDetectionStrategy, Component, InjectionToken, OnInit, PLATFORM_ID, inject, signal } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { ModalController } from '@ionic/angular';
import { constructorDeVoz } from 'src/app/utils/reconocimiento-voz';

/**
 * ¿Tiene este navegador reconocimiento de voz? En el servidor no se sabe: se da por sí para
 * que el botón venga ya en el HTML (antes no salía hasta el primer toque, porque la Home
 * arranca Angular al interactuar), y el navegador lo oculta si no tiene voz (Firefox).
 */
export const HAY_VOZ = new InjectionToken<boolean>('HAY_VOZ', {
  providedIn: 'root',
  factory: () => !isPlatformBrowser(inject(PLATFORM_ID)) || !!constructorDeVoz(window),
});

/**
 * El micrófono dentro del buscador (diseño 23): abre la ventana de búsqueda por voz.
 * En navegadores sin reconocimiento de voz (Firefox) no se pinta. Spec: odd/tasks/tiendas-voz-cabecera.md, S4.
 */
@Component({
  selector: 'app-boton-voz',
  standalone: true,
  template: `
      <button type="button" class="micro" aria-label="Buscar con la voz" [hidden]="!visible()" (click)="abrir()">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" aria-hidden="true"><rect x="9" y="3" width="6" height="11" rx="3"/><path d="M5 11a7 7 0 0 0 14 0M12 18v3"/></svg>
      </button>
  `,
  styles: [`
    :host { display: contents; }
    .micro {
      width: 36px; height: 36px; flex-shrink: 0;
      border-radius: 50%; border: 0;
      background: #fff; color: #C81A20;
      display: inline-flex; align-items: center; justify-content: center;
      box-shadow: 0 1px 3px rgba(23, 21, 26, 0.12);
      cursor: pointer;
    }
    .micro[hidden] { display: none; }
    .micro:focus-visible { outline: 2px solid #C81A20; outline-offset: 2px; }
  `],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BotonVozComponent implements OnInit {
  private modal = inject(ModalController);
  private hayVoz = inject(HAY_VOZ);

  /** Misma estructura en servidor y navegador (la hidratación casa); sólo cambia `hidden`. */
  readonly visible = signal(true);

  ngOnInit() {
    this.visible.set(this.hayVoz);
  }

  async abrir() {
    const { BusquedaVozComponent } = await import('../busqueda-voz/busqueda-voz.component');
    const ventana = await this.modal.create({ component: BusquedaVozComponent, cssClass: 'modal-voz' });
    await ventana.present();
  }
}
